module.exports = "/assets/b8ceeb9edd408250bb3f562b76e460a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KB.png
// module id = 1539
// module chunks = 0